export class ModelUser {
  public strEmail:string;
  public strPassword:string;


  constructor() {
     this.strEmail = '';
     this.strPassword = '';
  }

};